import { IPermissionProps } from '@/types/shared'
import { getConversationById } from '@/modules/Marketing/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { Loading } from 'vnetwork-ui'
import WelcomeMessage from './WelcomeMessage'
import { Actors, ConversationData } from '@/modules/Marketing/types/response'
import Message from './Message'
import Assignment from './Assignment'
import ThreadStatusChange from './ThreadStatusChange'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface ContactConversationProps extends IPermissionProps {
    conversationId?: number
    assignee?: Actors
}

const ContactConversation: React.FC<ContactConversationProps> = ({
    conversationId,
    assignee,
}) => {
    const { data, renderState } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.CONTACT_SOURCE_DETAIL, conversationId],
            queryFn: async () => {
                if (!conversationId) throw new Error('Missing conversationId')
                return await getConversationById(conversationId)
            },
            enabled: !!conversationId,
        },
        {
            errorDisplayMode: 'page',
            loadingComponent: (
                <div className="flex justify-center items-center py-8">
                    <Loading.CircularProgress width={20} height={20} />
                </div>
            ),
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    // API returns { data: { conversation, messages }, status } format

    const rawData = data as any
    const conversationData = (rawData?.result || rawData?.data) as
        | ConversationData
        | undefined
    const messages = conversationData?.messages || []

    return (
        <div className="bg-gradient-to-b from-gray-50 to-white rounded-lg p-4 space-y-3">
            {messages.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    <svg
                        className="w-12 h-12 mx-auto mb-3 text-gray-300"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                        />
                    </svg>
                    <p className="text-sm">Chưa có tin nhắn nào</p>
                </div>
            ) : (
                messages.map((message, index) => {
                    if (message?.type === 'WELCOME_MESSAGE') {
                        return <WelcomeMessage message={message} key={index} />
                    }
                    if (message?.type === 'MESSAGE') {
                        return (
                            <Message
                                className={index > 0 ? 'mt-3' : ''}
                                message={message}
                                assignee={assignee}
                                key={index}
                            />
                        )
                    }
                    if (message?.type === 'ASSIGNMENT') {
                        return <Assignment message={message} key={index} />
                    }
                    if (message?.type === 'THREAD_STATUS_CHANGE') {
                        return (
                            <ThreadStatusChange message={message} key={index} />
                        )
                    }
                    return null
                })
            )}
        </div>
    )
}
export default ContactConversation
